import {h} from 'preact';

const List = ( {children, ...props} ) =>
    <div {...props} className="flex flex-col m-0 p-0 w-full">{children}</div>;

export default List;
